import { Injectable } from '@angular/core';
import * as Models from "../models/commonModels";
import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';


export class BaseState<T> {

  ///Metoda do zarządzania
  PatchReportContext(Name: string, IsProcessing: boolean, Context: StateContext<T>) {
    if (IsProcessing) {
      Context.setState(
        patch({
          Report: Models.ReportProcessing.Start(Name),
        })
      );
    }
    else {
      Context.setState(
        patch({
          Report: Models.ReportProcessing.End(Name),
        })
      );
    }
  }
}


export interface BaseStateInterface {
  Report: Models.ReportProcessing;
}
